"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDirectDebitWidgets = void 0;
var DirectDebitAccountNumberCollapseLabelWidget_1 = require("./DirectDebitAccountNumberCollapseLabelWidget");
var SortCodeInputWithInfoQuestionWidget_1 = require("./SortCodeInputWithInfoQuestionWidget");
var ConfirmDirectDebitModalWidget_1 = require("./ConfirmDirectDebitModalWidget");
var DirectDebitAccountNamelWidget_1 = require("./DirectDebitAccountNamelWidget");
var addDirectDebitWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitAccountNumberCollapseLabelWidget",
        component: DirectDebitAccountNumberCollapseLabelWidget_1.DirectDebitAccountNumberCollapseLabelWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "sortCodeInputWithInfoQuestionWidget",
        component: SortCodeInputWithInfoQuestionWidget_1.SortCodeInputWithInfoQuestionWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "confirmDirectDebitModalWidget",
        component: ConfirmDirectDebitModalWidget_1.ConfirmDirectDebitModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "directDebitAccountNameWidget",
        component: DirectDebitAccountNamelWidget_1.DirectDebitAccountNameWidget
    });
};
exports.addDirectDebitWidgets = addDirectDebitWidgets;
//# sourceMappingURL=index.js.map